export default {
	invoice: {
		open: 'Offene',
		date: 'Rechnungsdatum',
		details: 'Rechnungsdetails',
		journalText: 'Buchungstext',
		received_at: 'Erhalten am',
		buildingId: 'Gebäude-ID',
		amounts: 'Beträge',
		total_amount: 'Rechnungsbetrag',
		recognized_amount: 'Anerkannter Betrag',
		approved_amount: 'Genehmigter Betrag',
		approved_total_amount: 'Genehmigter Gesamtbetrag',
		due_date: 'Fälligkeitsdatum',
		ledgerAccount: 'Buchungskonto',
		approvedOn: 'Genehmigt am',
		fiscalYear: 'Wirtschaftsjahr',
		purpose: 'Verwendungszweck',
		invoiceItems: 'Rechnungspositionen',
		item: 'Position | Positionen',
		subInvoice: 'Teilrechnung | Teilrechnungen',
		approved: 'Anerkannt',
		hide: 'Ausblenden',
		show: 'Anzeigen',
		noPreview: 'Keine Vorschau verfügbar',
	},
}
